import { Box, type Colors, Icon, NumberBadge, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import * as styles from './index.vanilla.css'
import VerticalLineSVG from './verticalLineSVG'

interface StepsData {
  badgeBackgroundColour: Colors
  badgeTextColour: Colors
  title: string
  description: string
  mins: number
}

const getStepsData: () => StepsData[] = () => [
  {
    badgeBackgroundColour: 'viridian200',
    badgeTextColour: 'viridian1000',
    title: i18n.t('project_management.landing_page.steps_section.steps.step_1.title'),
    description: i18n.t('project_management.landing_page.steps_section.steps.step_1.description'),
    mins: 1,
  },
  {
    badgeBackgroundColour: 'viridian600',
    badgeTextColour: 'grey1000',
    title: i18n.t('project_management.landing_page.steps_section.steps.step_2.title'),
    description: i18n.t('project_management.landing_page.steps_section.steps.step_2.description'),
    mins: 3,
  },
  {
    badgeBackgroundColour: 'viridian1000',
    badgeTextColour: 'grey1000',
    title: i18n.t('project_management.landing_page.steps_section.steps.step_3.title'),
    description: i18n.t('project_management.landing_page.steps_section.steps.step_3.description'),
    mins: 1,
  },
]

const Steps: React.FC = () => {
  const stepsData = getStepsData()

  return (
    <>
      <div className={styles.timeLine}></div>
      <Box flexDirection="row" justifyContent="spaceAround" alignItems="stretch">
        {stepsData.map(({ badgeBackgroundColour, badgeTextColour }, i) => (
          <div key={i}>
            <div className={styles.numberBagdeContainer}>
              <NumberBadge
                label={i + 1}
                color={badgeBackgroundColour}
                textColor={badgeTextColour}
              />
            </div>
            <div className={styles.verticalLine}>
              <VerticalLineSVG />
            </div>
          </div>
        ))}
      </Box>
      <Box flexDirection="row" justifyContent="spaceAround" alignItems="stretch" gap="s48">
        {stepsData.map(({ title, description, mins }) => (
          <Box
            key={title}
            flexDirection="column"
            justifyContent="spaceBetween"
            maxWidth="s400"
            padding="s24"
            gap="s16"
            className={styles.card}
          >
            <Box gap="s16">
              <Box gap="s1" minHeight="s64">
                <Text.Normal htmlTag="h3" weight="medium">
                  {title}
                </Text.Normal>
              </Box>
              <Text.Normal>{description}</Text.Normal>
            </Box>
            <Box flexDirection="row" gap="s4" alignItems="center">
              <Icon.Medium icon="clock" color="grey700" />{' '}
              <Text size="200" color="grey700">
                {`${mins} ${i18n.t(
                  'project_management.landing_page.steps_section.minutes_abbreviation'
                )}`}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
    </>
  )
}

export default Steps
